import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const entitiesService = {
  /**
   * Retorna espelho completo das entidades de negócio do usuário
   * Estrutura flat com IDs explícitos de link tables
   * GET /api/entities
   */
  getAll: async () => {
    const response = await api.get('/entities');
    return extractData(response.data);
  },
};

export default entitiesService;
